module.exports = __webpack_public_path__ + "static/media/dynamicFirstDayDelayAirplane.aa7bae50.jpg";